import InvestigationInteractor from "../../interactors/investigation_interactor";

export default {
  name: 'investigationInteractor',
  fn: InvestigationInteractor
};
